import {Component, Inject, Input} from '@angular/core';
import {StateService} from "@uirouter/core";
import {DOCUMENT} from "@angular/common";
import * as _ from 'lodash';

import {
    MenuService,
    ParametersService,
    SubtitlesService, ViewsService,
    ZonesService,
    ZonesSystemService
} from "../../core";
import {AdditionalContact, AdditionalContactViewData} from "../../models";

@Component({
    selector: 'additional-contact',
    templateUrl: './additional-contact.component.html',
    styleUrls: ['./additional-contact.component.scss']
})
export class AdditionalContactComponent {
    @Input() tile: AdditionalContact;

    constructor(
        @Inject(DOCUMENT) private document: Document,
        private menu: MenuService,
        private parameters: ParametersService,
        private $state: StateService,
        private subtitles: SubtitlesService,
        public views: ViewsService,
        public zones: ZonesService,
        public zonesSystem: ZonesSystemService,
    ) {
    }

    subtitle(val: number): string {
        return this.subtitles.setSubtitle(val);
    }

    setTemplate(tile: AdditionalContact) {
         if (window.innerWidth <= 696) {
            const additionalContact: AdditionalContactViewData = {
                description: {
                    name: this.zones.setTileName(tile.textNumber, 729),
                    styleIcon: 'relay',
                },
                tile,
            };
            this.zones.selectedZone = _.cloneDeep(additionalContact);
            this.$state.go('additional_contact_select', {
                selectedModuleHash: this.parameters.selectedModuleHash
            });
        } else {
             this.goToZonesMenu(tile);
         }
    }
    goToZonesMenu(tile: AdditionalContact) {
        if(!this.tile.submenuElementId) {
            this.setSubmenuElementId();
        }
        this.zones.goToMenu(tile, this.tile.submenuElementId);
    }

    private setSubmenuElementId() {
        this.menu.getElementMenu(this.tile.menuId); // menu element for tile
        this.menu.getMenuChildElement(this.menu.elementMenu) // set menu.submenu
        if (this.menu.submenu[0]) {
            this.tile.submenuElementId = this.menu.submenu[0].id;
        }
    }
}
